<p-toast />
<p-confirmDialog />
<!-- Read-only mode message -->
<div *ngIf="isReadOnlyMode" class="p-d-flex p-jc-center p-ai-center p-mb-3" style="width: 100%;">
  <div style="width: 100%; max-width: 700px; font-size: 1.1rem; padding: 0.75rem 1.5rem;">
    <p-message severity="info" text="This page is in read-only mode. Editing is disabled."></p-message>
  </div>
</div>
<app-donation-batch-header *ngIf="showHeader" [headerInfo]="headerModel" />


<h1 *ngIf="!showHeader">Add New Donation</h1>
<form [formGroup]="donationForm" (ngSubmit)="onSubmit()">
  <p-stepper orientation="vertical"
             (activeStepChange)="stepChange($event)"
             [linear]="true"
             #addDonationStepper>

    <!-- Donor Selection -->
    <p-stepperPanel header="Donor">
      <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">

        <div *ngIf="!showDonorInfo">
          <p-card>
            <div class="my-3">
              <rc-generic-button level="secondary"
                                 label="Select Existing Donor"
                                 (click)="showDonorSearch()"
                                 [disabled]="isReadOnlyMode"
                                 data-cy="btn-select-existing-donor" />
            </div>
          </p-card>
        </div>

        <div *ngIf="showDonorInfo">
          <p-card data-cy="donor-info-form">
            <div class="my-3 flex align-items-center gap-3">

              <strong *ngIf="!donorDisplayInfo">{{ donorName }}</strong> <strong *ngIf="donorDisplayInfo">{{ donorDisplayInfo }}</strong> ({{ donorId }})
              <span *ngIf="donorCity || donorState"> {{ donorCity }}<span *ngIf="donorCity && donorState">, </span>{{ donorState }}</span>

              <p-button styleClass="p-button-icon-red-light mx-1"
                        icon="fa-sharp fa-light fa-circle-xmark"
                        title="Delete"
                        (click)="deleteDonor($event)" />
            </div>
          </p-card>

          <p-card>
            <rc-generic-button level="secondary"
                               label="Next"
                               (click)="nextCallback.emit()"
                               data-cy="btn-next" />
          </p-card>
        </div>

      </ng-template>
    </p-stepperPanel>

    <!-- Donation Amount Step -->
    <p-stepperPanel header="Donation Amount">
      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">

        <p-card>
          <div class="formgrid grid" data-cy="donation-amount-form">
            <!-- Amount -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="amount" class="field-label required">Amount</label>
              <input id="amount"
                     formControlName="amount"
                     type="text"
                     placeholder="$"
                     pInputText
                     data-cy="input-amount"
                     (input)="onAmountInput($event, 'amount')" />
              <small *ngIf="donationForm.get('amount')?.invalid && donationForm.get('amount')?.touched" class="block p-error">
                Amount is required and must be greater than zero.
              </small>
            </div>

            <!-- Date -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="date" class="field-label required">
                Date
                <i [class.fa-lock]="fieldLockStatus['date']"
                   [class.fa-lock-open]="!fieldLockStatus['date']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('date')"
                   title="{{ fieldLockStatus['date'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-calendar id="date" formControlName="date" [showIcon]="true" [iconDisplay]="'input'" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" data-cy="input-date"></p-calendar>
              <small *ngIf="donationForm.get('date')?.invalid && donationForm.get('date')?.touched" class="block p-error">
                Please select a date.
              </small>
            </div>

            <!-- Pledged -->
            <div class="field-checkbox sm:pt-5 sm:mt-1 align-items-start col-12 sm:col-3">
              <p-checkbox formControlName="pledged" binary="true"></p-checkbox>
              <label for="pledged">Pledged</label>
            </div>

          </div>
        </p-card>

        <p-card>
          <div class="formgrid grid">

            <!-- Fund Code -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="fundCode" class="field-label required">
                Fund Code
                <i [class.fa-lock]="fieldLockStatus['fundCode']"
                   [class.fa-lock-open]="!fieldLockStatus['fundCode']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('fundCode')"
                   title="{{ fieldLockStatus['fundCode'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-autoComplete id="fundCode"
                              formControlName="fundCode"
                              [suggestions]="fundCodeSuggestions"
                              (completeMethod)="searchFundCode($event.query)"
                              (onSelect)="onFundCodeSelect($event)"
                              placeholder="Search for Fund code"
                              data-cy="auto-fundcode"></p-autoComplete>
              <div *ngIf="donationForm.get('fundCode')?.touched || donationForm.get('fundCode')?.dirty">
                <div *ngIf="donationForm.get('fundCode')?.errors?.['invalidSelection'] && !donationForm.get('fundCode')?.errors?.['required']">
                  <small class="block p-error">Please enter a valid fund code.</small>
                </div>
                <div *ngIf="donationForm.get('fundCode')?.errors?.['required']">
                  <small class="block p-error">Please enter the fund code.</small>
                </div>
              </div>
            </div>

            <!-- Contribution Source -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="contributionSource" class="field-label required">
                Contribution Source
                <i [class.fa-lock]="fieldLockStatus['contributionSourceId']"
                   [class.fa-lock-open]="!fieldLockStatus['contributionSourceId']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('contributionSourceId')"
                   title="{{ fieldLockStatus['contributionSourceId'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-dropdown id="contributionSource"
                          formControlName="contributionSourceId"
                          [options]="contributionSourceOptions"
                          placeholder="Please Select"
                          data-cy="dropdown-source"></p-dropdown>
              <small *ngIf="donationForm.get('contributionSourceId')?.invalid && donationForm.get('contributionSourceId')?.touched" class="block p-error">
                Please select the contribution source.
              </small>
            </div>

            <!-- Contribution Type -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="contributionType" class="field-label required">
                Contribution Type
                <i [class.fa-lock]="fieldLockStatus['contributionTypeId']"
                   [class.fa-lock-open]="!fieldLockStatus['contributionTypeId']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('contributionTypeId')"
                   title="{{ fieldLockStatus['contributionTypeId'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-dropdown id="contributionType"
                          formControlName="contributionTypeId"
                          [options]="contributionTypeOptions"
                          placeholder="Please Select"
                          data-cy="dropdown-type"></p-dropdown>
              <small *ngIf="donationForm.get('contributionTypeId')?.invalid && donationForm.get('contributionTypeId')?.touched" class="block p-error">
                Please select the contribution type.
              </small>
            </div>

            <!-- Check Number -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="checkNumber" class="field-label">Check Number</label>
              <input id="checkNumber" formControlName="checkNumber" type="text" pInputText data-cy="input-checknumber" />
            </div>
          </div>
        </p-card>

        <p-card>
          <rc-generic-button level="secondary" borderStyle="outline" label="Previous" (click)="prevCallback.emit()" [classes]="['mr-1']" data-cy="btn-back" />
          <rc-generic-button level="secondary" borderStyle="solid" label="Next" (click)="onStep2NextClick()" data-cy="btn-next" />

          <!-- <p-button label="Previous" severity="secondary" (onClick)="prevCallback.emit()"></p-button>
          <p-button label="Next" (onClick)="onStep2NextClick()"></p-button> -->
        </p-card>

      </ng-template>
    </p-stepperPanel>

    <!-- Donation Attributes -->
    <p-stepperPanel header="Donation Attributes">
      <ng-template pTemplate="content" let-prevCallback="prevCallback">

        <!-- Events and Fundraisers -->
        <p-card>
          <div class="grid gap-5" data-cy="donation-attributes-form">
            <div class="col">
              <div class="formgrid grid">
                <div class="field col-12 sm:col-6">
                  <label for="eventCode" class="field-label">
                    Event Code
                    <i [class.fa-lock]="fieldLockStatus['eventCode']"
                       [class.fa-lock-open]="!fieldLockStatus['eventCode']"
                       class="lock-icon fa-sharp fa-regular fa-lock-open"
                       (click)="toggleFieldLock('eventCode')"
                       title="{{ fieldLockStatus['eventCode'] ? 'Unlocked' : 'Locked' }}"></i>
                  </label>
                  <p-autoComplete id="eventCode"
                                  formControlName="eventCode"
                                  [suggestions]="eventCodeSuggestions"
                                  (onSelect)="onEventCodeSelect($event)"
                                  (completeMethod)="searchEventCode($event.query)"
                                  placeholder="Search for Event code"
                                  data-cy="auto-event-code"></p-autoComplete>

                  <div class="mt-2">
                    <rc-generic-button label="Add New Event" iconImg="plus" borderStyle="text-only" level="secondary" size="small" (click)="addNewEvent($event)" data-cy="btn-add-new-event" />
                  </div>
                </div>

                <div class="field col-12 sm:col-6">
                  <label for="fundraisers" class="field-label">
                    Fundraisers
                    <i [class.fa-lock]="fieldLockStatus['fundraiser']"
                       [class.fa-lock-open]="!fieldLockStatus['fundraiser']"
                       class="lock-icon fa-sharp fa-regular fa-lock-open"
                       (click)="toggleFieldLock('fundraiser')"
                       title="{{ fieldLockStatus['fundraiser'] ? 'Unlocked' : 'Locked' }}"></i>
                  </label>
                  <p-autoComplete id="fundraisers"
                                  formControlName="fundraiser"
                                  [suggestions]="fundraiserSuggestions"
                                  (onSelect)="onFundraiserSelect($event)"
                                  (completeMethod)="searchFundraisers($event.query)"
                                  placeholder="Search for Fundraisers"
                                  data-cy="auto-fundraisers"></p-autoComplete>
                  <div class="mt-2">
                    <rc-generic-button label="Add New Fundraiser" iconImg="plus" borderStyle="text-only" level="secondary" size="small" (click)="addNewFundraiser($event)" data-cy="btn-add-new-fundraiser" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 xl:col-5 xxl:col-4 section-divider" *ngIf="selectedFundraisers.length > 0">

              <p-table [value]="selectedFundraisers" styleClass="datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Fundraiser Name</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-fundraiser>
                  <tr>
                    <td>{{ fundraiser.fundraiserName }}</td>
                    <td>
                      <rc-generic-button label="Remove" iconImg="trash" iconColor="red-light" [isIconOnly]="true"
                                         [classes]="['table-action-btn']" (click)="removeFundraiser(fundraiser)" data-cy="btn-delete" />
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-card>

        <!-- FEC info -->
        <p-card>
          <div class="formgrid grid gap-3">
            <!-- FEC Line Number -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="fecLineNumber" class="field-label required">
                FEC Line Number
                <i [class.fa-lock]="fieldLockStatus['fecLineNumberId']"
                   [class.fa-lock-open]="!fieldLockStatus['fecLineNumberId']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('fecLineNumberId')"
                   title="{{ fieldLockStatus['fecLineNumberId'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-dropdown id="fecLineNumber"
                          formControlName="fecLineNumberId"
                          [options]="fecLineOptions"
                          placeholder="Select FEC Line Number"
                          data-cy="dropdown-fecLineNumber"></p-dropdown>
              <small *ngIf="donationForm.get('fecLineNumberId')?.invalid && donationForm.get('fecLineNumberId')?.touched" class="block p-error">
                Please select the FEC line number.
              </small>
            </div>

            <!-- Donation Flags -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="donationFlags" class="field-label">
                Donation Flags
                <i [class.fa-lock]="fieldLockStatus['donationFlag']"
                   [class.fa-lock-open]="!fieldLockStatus['donationFlag']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('donationFlag')"
                   title="{{ fieldLockStatus['donationFlag'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-autoComplete formControlName="donationFlag"
                              [suggestions]="donationFlagSuggestions"
                              (completeMethod)="searchDonationFlags($event.query)"
                              (onSelect)="onDonationFlagSelect($event)"
                              placeholder="Search and select a donation flag"
                              data-cy="auto-donationFlags"></p-autoComplete>
              <div class="mt-2">
                <rc-generic-button label="Add New Donation Flag" iconImg="plus" borderStyle="text-only" level="secondary" size="small" (click)="addNewDonationFlag($event)" data-cy="btn-add-new-donationFlag" />
              </div>
            </div>

            <div class="col-12 xl:col-5 xxl:col-4 section-divider" *ngIf="selectedDonationFlags.length > 0">
              <p-table [value]="selectedDonationFlags" styleClass="datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Flag Name</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-flag>
                  <tr>
                    <td>{{ flag.name }}</td>
                    <td>
                      <rc-generic-button label="Remove"
                                         iconImg="trash"
                                         iconColor="red-light"
                                         [isIconOnly]="true"
                                         [classes]="['table-action-btn']"
                                         (click)="removeDonationFlag(flag)"
                                         data-cy="btn-delete" />
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <!-- Is Memo -->
            <div class="field-checkbox col-12 sm:col-6 xl:col-3">
              <p-checkbox formControlName="isMemo" binary="true"></p-checkbox>
              <label for="isMemo">Is Memo</label>
            </div>

            <!-- Memo Text -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="memoText" class="field-label">Memo Text</label>
              <textarea id="memoText" formControlName="memoText" rows="3" pInputTextarea data-cy="input-memoText"></textarea>
            </div>

            <!-- FEC Description -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="fecDescription" class="field-label">FEC Description</label>
              <textarea id="fecDescription" formControlName="fecDescription" rows="3" pInputTextarea data-cy="input-fecDescription"></textarea>
            </div>

            <!-- Custom Note -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="customNote" class="field-label">Custom Note</label>
              <textarea id="customNote" formControlName="notes" rows="3" pInputTextarea data-cy="input-customNote"></textarea>
            </div>
          </div>
        </p-card>

        <p-card>
          <div class="formgrid grid">
            <!-- Parent/Child Section -->
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="parentChildDonation" class="field-label">Parent/Child Donation</label>
              <p-dropdown id="parentChildDonation"
                          formControlName="parentChildDonation"
                          [options]="parentChildOptions"
                          placeholder="Select Parent/Child Donation"
                          (onChange)="onParentChildDonationChange($event)"
                          data-cy="dropdown-parentChildDonation"></p-dropdown>
              <small *ngIf="donationForm.get('parentChildDonation')?.invalid && donationForm.get('parentChildDonation')?.touched" class="block p-error">
                Please select the parent/child donation type.
              </small>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3" *ngIf="isParentDonation || isChildDonation">
              <label for="parentDonationType" class="field-label required">
                Parent Donation Type
                <i [class.fa-lock]="fieldLockStatus['transferTypeId']"
                   [class.fa-lock-open]="!fieldLockStatus['transferTypeId']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('transferTypeId')"
                   title="{{ fieldLockStatus['transferTypeId'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-dropdown id="parentDonationType"
                          formControlName="transferTypeId"
                          [options]="parentDonationTypeOptions"
                          placeholder="Please Select"
                          (onChange)="onParentDonationTypeChange($event)"
                          data-cy="dropdown-parentDonationType"></p-dropdown>
              <div *ngIf="donationForm.get('transferTypeId')?.invalid && donationForm.get('transferTypeId')?.touched">
                <small *ngIf="donationForm.get('transferTypeId')?.hasError('required')" class="block p-error">Please enter the parent  donation type.</small>
              </div>
            </div>

            <div class="field-checkbox col-12 sm:col-6 xl:col-6  sm:pt-5 sm:mt-1 align-items-start" *ngIf="isParentDonation && showPacLimitNotAffected">
              <p-checkbox formControlName="pacLimitNotAffected" binary="true"></p-checkbox>
              <label for="pacLimitNotAffected">PAC Limit Not Affected</label>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3" *ngIf="isChildDonation">
              <label for="parentDonationName" class="field-label required">
                Parent Donation Name
                <i [class.fa-lock]="fieldLockStatus['parentDonationName']"
                   [class.fa-lock-open]="!fieldLockStatus['parentDonationName']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('parentDonationName')"
                   title="{{ fieldLockStatus['parentDonationName'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-autoComplete id="parentDonationName"
                              formControlName="parentDonationName"
                              [suggestions]="parentDonationNameSuggestions"
                              (completeMethod)="searchParentDonationNames($event.query)"
                              (onSelect)="onParentDonorSelect($event)"
                              placeholder="Search for Parent donation"
                              data-cy="auto-parentDonationName"></p-autoComplete>
              <div *ngIf="donationForm.get('parentDonationName')?.invalid && donationForm.get('parentDonationName')?.touched">
                <small *ngIf="donationForm.get('parentDonationName')?.hasError('required')" class="block p-error">Please enter parent donation name.</small>
              </div>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3" *ngIf="isChildDonation">
              <label for="parentDonationNumber" class="field-label required">
                Parent Donation Number
                <i [class.fa-lock]="fieldLockStatus['parentDonationNumber']"
                   [class.fa-lock-open]="!fieldLockStatus['parentDonationNumber']"
                   class="lock-icon fa-sharp fa-regular fa-lock-open"
                   (click)="toggleFieldLock('parentDonationNumber')"
                   title="{{ fieldLockStatus['parentDonationNumber'] ? 'Unlocked' : 'Locked' }}"></i>
              </label>
              <p-dropdown id="parentDonationNumber"
                          formControlName="parentDonationNumber"
                          [options]="parentDonorDonationsOptions"
                          placeholder="Please Select"
                          data-cy="dropdown-parentDonationNumber"></p-dropdown>
              <div *ngIf="donationForm.get('parentDonationNumber')?.invalid && donationForm.get('parentDonationNumber')?.touched">
                <small *ngIf="donationForm.get('parentDonationNumber')?.hasError('required')" class="block p-error">Please enter parent donation number.</small>
              </div>
            </div>
          </div>
        </p-card>


        <p-card>
          <rc-generic-button level="secondary"
                             label="Previous"
                             (click)="prevCallback.emit()"
                             data-cy="btn-back" />
        </p-card>

      </ng-template>
    </p-stepperPanel>
  </p-stepper>
  <p-card styleClass="page-footer">
    <rc-generic-button label="Cancel"
                       borderStyle="text-only"
                       data-cy="btn-cancel"
                       (click)="cancelDonation()"
                       [disabled]="activeIndex !== steps.length - 1" />
    <rc-generic-button label="Save + Add New"
                       borderStyle="outline"
                       [classes]="['mx-2']"
                       (click)="saveDonation('addNew')"
                       data-cy="btn-save-new"
                       [disabled]="activeIndex !== steps.length - 1" />
    <rc-generic-button label="Save + Exit"
                       (click)="saveDonation('exit')"
                       data-cy="btn-save-exit"
                       [disabled]="activeIndex !== steps.length - 1" />
  </p-card>

</form>



<!-- Add Event Modal -->
<app-event-modal [(visible)]="addEventDisplayModal"
                 (onCancel)="addEventDisplayModal = false"
                 (onSave)="saveEvent()"
                 [eventTypes]="eventTypes"></app-event-modal>



<!-- Add Fundraiser Modal -->
<app-fundraiser-modal [(visible)]="addFundraiserDisplayModal"
                      (onCancel)="addFundraiserDisplayModal = false"
                      (onSave)="saveFundraiser($event)"
                      [states]="states"></app-fundraiser-modal>

<!-- Add Donation Flag Modal -->
<app-donation-flag-modal [visible]="showDonationFlagModal"
                         [isEditMode]="isEditDonationFlag"
                         [formData]="selectedDonationFlag"
                         [campaignId]="campaignId"
                         (save)="onSaveDonationFlag($event)"
                         (close)="showDonationFlagModal = false">
</app-donation-flag-modal>

<!-- Search Donors -->
<p-dialog [(visible)]="showDonorSearchDialog"
          [modal]="true"
          header="Search for a Donor"
          styleClass="p-dialog-static p-dialog-full-width fadeinright animation-duration-300">

  <app-donor-search *ngIf="showDonorSearchDialog"
                    [showInDialog]="true"
                    (cancelEvent)="hideDonorSearchDialog()"
                    (closeDonorSearch)="hideDonorSearchDialog()">
  </app-donor-search>

  <!--<ng-template pTemplate="footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" data-cy="btn-cancel" />
    <rc-generic-button label="Select Donor" data-cy="btn-select-donor" />
  </ng-template>-->

</p-dialog>


<!-- Add New Donor -->
<p-dialog [(visible)]="showAddNewDonorDialog"
          [modal]="true"
          [maximizable]="true"
          header="Add New Donor"
          styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

  <app-donor-add *ngIf="showAddNewDonorDialog"
                 (cancel)="showAddNewDonorDialog = false">
  </app-donor-add>

  <!--<ng-template pTemplate="footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" data-cy="btn-cancel" />
    <rc-generic-button label="Save" data-cy="btn-save" />
  </ng-template>-->

</p-dialog>

<!-- Donor Dedupe -->
<p-dialog [(visible)]="showDonorDedupeDialog"
          [modal]="true"
          [maximizable]="true"
          header="Compare and Dedupe Donors"
          styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

  <app-donor-dedupe *ngIf="showDonorDedupeDialog"
                    [selectedDonors]="dedupeDonors">
  </app-donor-dedupe>

</p-dialog>

<!-- Donor Giving History -->
<p-dialog [(visible)]="showDonorGivingHistoryDialog"
          [modal]="true"
          [maximizable]="true"
          header="Donor Giving History"
          styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

  <app-donor-fund-totals-grid *ngIf="showDonorGivingHistoryDialog"
                              [donorId]="selectedDonorGivingHistoryDonorId"
                              [displayOneModalPopup]="true">
  </app-donor-fund-totals-grid>

</p-dialog>

























































